import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { Helper } from '../Helpers/helper';

// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
declare var googleLoaded: any;

@Component({ standalone: false, selector: 'visiba-google-chart', host: { '[id]': 'id' }, template: '' })
export class VisibaGoogleChart {
	@Input() type: string;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	@Input() options: any = {};
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	@Input() data: any;

	id: string = 'vbla';
	yes: boolean = true;

	constructor(
		public _elementRef: ElementRef,
		private helper: Helper,
	) {
		this.id = Math.random().toString(36).substring(3);
	}

	ngAfterViewInit() {
		this.init();
	}

	init() {
		if (typeof google === 'undefined' || !google.charts) {
			window.setTimeout(() => {
				this.init();
			}, 1000);
			return;
		}

		google.charts.load('current', { packages: ['corechart'] });
		google.charts.setOnLoadCallback(() => {
			this.draw();
		});
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.draw();
	}

	draw = () => {
		if (typeof this.data === 'undefined' || this.data === null || this.data === '' || this.data.length === 0) return;

		if (!google.visualization || !google.visualization.ChartWrapper) {
			window.setTimeout(this.draw, 500);
			return;
		}

		let options = this.defaultOptions();
		this.helper.object.merge(options, this.options);

		if (typeof this.options['extraWidth'] === 'number') {
			options['width'] += this.options['extraWidth'];
		}
		new google.visualization.ChartWrapper({
			chartType: this.type,
			dataTable: this.data,
			options: options,
			containerId: this.id,
		}).draw();
	};

	// biome-ignore lint/complexity/noBannedTypes: suppressed due to migration - should be fixed
	defaultOptions(): Object {
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		let opt: any = {
			width: this._elementRef.nativeElement.parentNode.clientWidth,
			chartArea: { width: '85%', height: '65%' },
			legend: { position: 'bottom', alignment: 'end' },
			colors: ['008296'],
		};
		return opt;
	}
}
